import React, {Fragment} from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import StarRating from '@homeaway/react-star-rating';
const RatingElement = ({averageRating, reviewCount, starSize, isDualPrice}) => {
    if (!reviewCount) {
        return (
            <span className="sr-only">
                <FormattedMessage id="noReviews" defaultMessage="no reviews" />
            </span>
        );
    }

    let starRatingProps = {
        rating: averageRating,
        size: starSize,
    };

    if (isDualPrice) {
        starRatingProps = {
            ...starRatingProps,
            useSingleStar: true,
            label: (
                <span className="Rating__starRating--label">
                    {averageRating.toFixed(1)}
                </span>
            ),
        };
    }

    const ratingCountClass = classNames({
        'Rating__starRating--ratingcount': isDualPrice,
    });

    return (
        <Fragment>
            <div className={'Rating__starRating'} aria-hidden="true">
                <StarRating {...starRatingProps} />
            </div>
            <span className={ratingCountClass} aria-hidden="true">
                {`(${reviewCount})`}
            </span>
            <span className="sr-only">
                <FormattedMessage
                    id="ratingScreenReaderLabel"
                    defaultMessage="Guest Rating: {rating} out of possible 5 stars. Number of Reviews: {reviewCount}"
                    values={{
                        rating: averageRating.toFixed(2),
                        reviewCount,
                    }}
                />
            </span>
        </Fragment>
    );
};

export default RatingElement;
